module.exports = __webpack_public_path__ + "img/gh.a727698c.svg";